import HeroSection from './components/HeroSection';
import FeaturedMovies from './components/FeaturedMovies';
import MovieCategories from './components/MovieCategories';
import LatestMovies from './components/LatestMovies';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: '小草影院 - 院线大片与最新上映电影大全',
            description: '小草影院汇集院线大片、最新上映电影及动作片、喜剧电影等分类大全。每日更新，高清在线观看各类影片。',
            url: 'https://xiaocaocinema.com/',
            isPartOf: {
              '@type': 'WebSite',
              name: '小草影院',
              url: 'https://xiaocaocinema.com/',
            },
            breadcrumb: {
              '@type': 'BreadcrumbList',
              itemListElement: [
                {
                  '@type': 'ListItem',
                  position: 1,
                  name: '首页',
                  item: 'https://xiaocaocinema.com/',
                },
              ],
            },
          }),
        }}
      />
      <HeroSection />
      <FeaturedMovies />
      <MovieCategories />
      <LatestMovies />
      <CTASection />
      <FAQSection />
    </>
  );
}